<!-- eslint-disable vue/valid-v-bind -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
    <v-container class="pa-0">
        <v-container
            v-if="userCurrentPlan != undefined && userCurrentPlan != null"
            class="wrapper-vmenu pa-0"
        >
            <v-menu
                v-model="planMenu"
                :close-on-content-click="false"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-container
                        class="wrapper-user-data d-flex justify-space-between align-center"
                        :class="{ 'gap-2' : !isMobile || isTablet }"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div class="d-flex align-center">
                            <v-icon size="15">mdi-chevron-down</v-icon>
                        </div>
                        <div class="d-flex align-center gap-2">
                          <v-card-text
                            v-if="!isMobile || isTablet"
                            class="text-caption text-end pa-0"
                            style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 8pt !important;"
                          >
                            {{ userInfo?.init?.abrName }}
                            <br />
                            <span style="color: #a19e9e;font-size: 7.5pt;">
                              #{{ userInfo?.init?.abrKey }}
                            </span>
                          </v-card-text>
                          <img
                            :src="userInfo?.init?.logo?.link || require('@/assets/logo-abr-iron.png')"
                          />
                        </div>
                    </v-container>
                </template>
                <v-card
                    class="wrapper-menu ma-0"
                >
                    <v-container class="d-flex justify-space-between pa-0 mb-3">
                        <span class="text-caption" style="color: #a3a2a2;">{{ $t('current-subscription') }}</span>
                        <span class="text-caption">{{ userCurrentPlan.plan.name }}</span>
                    </v-container>
                    <v-container class="d-flex justify-space-between pa-0 mb-3">
                        <span class="text-caption" style="color: #a3a2a2;">{{ $t('subscription end date') }}</span>
                        <span class="text-caption">{{ userCurrentPlan.ends_at }}</span>
                    </v-container>
                    <v-container class="d-flex justify-space-between pa-0 mb-3">
                        <span class="text-caption" style="color: #a3a2a2;">{{ $t('sms-count') }}</span>
                        <span class="text-caption">{{ smsCountRemain > 0 ? smsCountRemain : 0 }}</span>
                    </v-container>
                    <v-divider class="mb-2" />
                    <v-card-text
                        class="role-button text-caption d-flex py-2 px-1 gap-2"
                        style="cursor: pointer;"
                        @click="$router.push({ name: 'plans' })"
                    >
                        <my-icon
                            :name="'shopping-cart'"
                            :width="18"
                            :height="18"
                            :cursor-pointer="true"
                        />
                        <span class="mt-1">{{ $t('Purchase and renewal of subscription') }}</span>
                    </v-card-text>
                    <v-card-text
                        class="role-button text-caption d-flex py-2 px-1 gap-2"
                        style="cursor: pointer;"
                        @click="chargingPanelSMS"
                    >
                        <my-icon
                            :name="'chat-comment'"
                            :width="18"
                            :height="18"
                            :cursor-pointer="true"
                        />
                        <span class="mt-1">{{ $t('increase SMS validity') }}</span>
                    </v-card-text>
                    <v-card-text
                        class="role-button text-caption d-flex py-2 px-1 gap-2"
                        style="cursor: pointer;"
                        @click="fetchUserAccounts"
                    >
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        size="18"
                        width="2"
                        color="secondary"
                      >
                      </v-progress-circular>
                      <v-icon size="18" v-else>mdi-widgets</v-icon>
                      <span class="mt-1">{{ $t('change-account') }}</span>
                    </v-card-text>
                </v-card>
            </v-menu>
        </v-container>
        <v-dialog
          v-model="selectAccountsDialog"
          width="430"
        >
          <v-card class="pa-5">
            <v-container class="pa-0 d-flex justify-space-between align-center mb-7">
              <v-card-text class="pa-0 text-body-1">{{ $t('accounts-list') }}</v-card-text>
              <v-icon size="17" @click="selectAccountsDialog = false">mdi-close</v-icon>
            </v-container>
            <v-sheet class="pa-0 d-flex flex-column gap-2 business-list">
              <v-btn
                v-for="item in userAccounts"
                :key="item.id"
                outlined
                :loading="loading"
                color="grey-darken-1"
                style="padding: 7px !important;border-color: silver;"
                class="business-item d-flex aling-center justify-center w-100"
                height="auto"
                @click="findBusiness(item)"
              >
                <v-container class="d-flex align-center justify-space-between pa-0">
                  <div class="d-flex align-center gap-3">
                    <img
                      :src="item.logo?.link || require('@/assets/logo-abr-iron.png')"
                      height="40"
                      width="40"
                      style="border: 1px solid silver;border-radius: 3px;"
                    />
                    <div>
                      <v-card-text
                        style="white-space: normal !important;word-break: break-word !important;max-width: 150px;display: block;"
                        class="pa-0 text-body-1 text-right mb-1"
                      >
                      {{ item.name ? item.name : '-' }}
                      </v-card-text>
                      <v-card-text class="pa-0 text-body-2 text-right" style="color: #938888;">
                        {{ item.app_key ? '#' + item.app_key : '-' }}
                      </v-card-text>
                    </div>
                  </div>
                  <div>
                    <v-chip
                      v-if="(item.plan_days_left == 0 || item.plan_days_left < 0)"
                      color="red"
                      small
                      style="color: #fff;padding: 0 5px;"
                    >
                    {{ $t('expired') }}
                    </v-chip>
                    <v-card-text
                      v-else
                      class="pa-0 text-body-2 text-right"
                      style="color: #938888;"
                    >
                      <span style="color: black;">{{ item.plan_days_left ? item.plan_days_left : '-' }}</span>
                      {{ $t('days-left') }}
                    </v-card-text>
                  </div>
                </v-container>
              </v-btn>
            </v-sheet>
            <v-btn
              outlined
              color="primary"
              class="mt-7 w-100"
              small
              height="42"
              @click="$router.push('/business-Info')"
            >
              {{ $t("create-new-business") }}
              <v-icon size="20" class="mr-2">mdi-plus</v-icon>
            </v-btn>
          </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import MyIcon from '@/views/dashboard/components/general/icon/MyIcon.vue'
import { mapState } from 'vuex'

export default {
  name: 'DashboardCoreAppBar',
  data () {
    return {
      planMenu: false,
      userInfo: null,
      userCurrentPlan: null,
      tokenUserApp: null,
      userAccounts: null,
      loading: false,
      selectAccountsDialog: false
    }
  },
  components: {
    MyIcon
  },
  computed: {
    ...mapState(['smsCountRemain', 'expireDate'])
  },
  methods: {
    fetchUserCurrentPlan () {
      var app = this
      app.$axios.get(app.$endpoint + 'get-user-plan')
        .then(r => {
          this.userCurrentPlan = r.data
          this.$store.commit('SET_USER_CURRENT_PLAN', this.userCurrentPlan)
          if (this.userCurrentPlan) {
            localStorage.setItem('hasTaxPayer', this.userCurrentPlan.has_taxpayer)
            this.setDobarePermission()
          }
        })
        .catch(err => {
          this.userCurrentPlan = err.response.data.data
          this.$store.commit('SET_USER_CURRENT_PLAN', this.userCurrentPlan)
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    chargingPanelSMS () {
      this.$router.push({ name: 'PlansCheckout', query: { chargingSMS: true, token: this.tokenUserApp ? this.tokenUserApp : null } })
    },
    setDobarePermission () {
      if (this.$store.state.userCurrentPlan != null) {
        const dobare = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'dobareSystem')
        if (dobare && dobare.value == 'active') {
          localStorage.setItem('hasDobarePermission', true)
        } else {
          localStorage.setItem('hasDobarePermission', false)
        }
      }
    },
    fetchUserAccounts () {
      var app = this
      app.loading = true
      app.$axios.post(app.$apipoint + 'v2/get-user-accounts')
        .then((r) => {
          this.userAccounts = r.data.accounts
          if (this.userAccounts && this.userAccounts.length > 0) {
            this.selectAccountsDialog = true
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.loading = false
        })
    },
    findBusiness (val) {
      var app = this
      app.loading = true
      this.$axios.post(this.$apipoint + 'v2/switch-account',
        {
          id: val.id
        }
      )
        .then((response) => {
          app.loading = false
          localStorage.setItem('token', JSON.stringify(response.data.meta))
          localStorage.setItem('fullname', response.data.username)
          app.$axios.defaults.headers.common.Authorization =
          'Bearer ' + response.data.token
          localStorage.setItem('APP_KEY', val.app_key)

          delete app.$axios.defaults.headers.common.x_api_key
          delete app.$axios.defaults.headers.common.domain

          // store js
          app.$store.commit('SET_FULLNAME', response.data.username)
          app.$store.commit(
            'SET_CURRENCY_SYMBOL',
            response.data.meta.init.currencySymbol
          )
          app.$store.commit('SET_FINANCIALYEAR', response.data.meta.init.financialYear)
          app.$store.commit(
            'SET_BACKGROUNDIMAGE',
            response.data.meta.init.backgroundImage
          )
          app.$store.commit(
            'SET_BACKGROUNDCOLOR',
            response.data.meta.init.backgroundColor
          )
          app.$store.commit('SET_START_DATE', response.data.meta.init.startDate)
          app.$store.commit('SET_END_DATE', response.data.meta.init.endDate)
          app.$store.commit('SET_THEME_COLOR', response.data.meta.init.theme_color.value)
          app.$store.commit('SET_DARK', response.data.meta.init.dark.value)
          app.$store.commit('SET_HOVERMENU', response.data.meta.init.hoverMenu.value)
          app.$store.commit(
            'SET_APPBARSOPACITY',
            response.data.meta.init.appBarsOpacity.value
          )
          app.$store.commit('SET_ACCESS', response.data.meta.init.access)
          app.$store.commit('SET_LANG', response.data.meta.init.lang.value)
          app.$store.commit('SET_RTL', response.data.meta.init.rtl.value)
          app.$store.commit('SET_DATE_LOCALE', response.data.meta.init.date_locale.value)
          app.$store.commit(
            'SET_NEGATIVE_INVENTORY',
            response.data.meta.init.negative_inventory.value
          )
          app.$store.commit('SET_CURRENCY', response.data.meta.init.currency)
          app.$store.commit('SET_MENU_BOOKMARK', response.data.meta.init.menuBookmark)
          app.$store.commit('SET_PERMISSIONS', response.data.meta.init.permissions)
          if (response.data.meta.init.teacherAccess) {
            app.$store.commit('SET_TEACHERACCESS', 'active')
            app.$router.push({ name: 'academyDashboard' })
          }
          if (app.shopProp) {
            app.$router.push({ path: 'shop/initialize' })
          }
          localStorage.setItem('apn', null)
          if (val.plan_days_left == 0 || val.plan_days_left < 0) {
            this.$router.push({ name: 'plans' })
          } else {
            app.$router.push('/')
          }

          this.userInfo = JSON.parse(localStorage.getItem('token'))
          this.selectAccountsDialog = false
        })
        .catch((err) => {
          app.loading = false
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.overlay = false
          app.loading = false
        })
    }
  },
  watch: {
  },
  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem('token'))
    this.fetchUserCurrentPlan()
    if (this.$route.query.token) {
      this.tokenUserApp = this.$route.query.token
    }
  }
}
</script>

<style scoped>
.wrapper-app-bar .v-toolbar__content .wrapper-user-data {
    border: 1px solid silver;
    width: auto;
    height: 38px;
    border-radius: 4px;
    padding: 4px !important;
    cursor: pointer;
}
.wrapper-app-bar .v-toolbar__content .wrapper-user-data img,
.wrapper-menu img {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  border: 1px solid #c0c0c038;
}
.wrapper-menu {
  padding: 10px;
  height: auto;
  overflow-y: clip;
  line-height: unset;
  width: 220px;
}
.wrapper-menu .role-button:hover {
    background-color: #fcfcfc;
}
/deep/ .wrapper-vmenu .v-menu__content {
    width: 190px;
    min-width: unset !important;
    max-width: unset !important;
    left: 0 !important;
    top: 38px !important;
}
.business-list {
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>
